module.exports = __webpack_public_path__ + "img/soquinho.4520f00b.png";